import Vue from 'vue';

// 跳转
Vue.mixin({
  methods: {
    // 跳转  jump(路由,参数)
    jump(url, params) {
      if (this.$router.app.$route.path === url) return;
      this.$router.push({
        path: url,
        query: {
          ...params,
        },
      });
      if (params.navIndex) {
        this.$store.state.tabIndex = params.navIndex;
      }
    },
  },
});

/**
 * 获取uuid
 */
export function getUUID() {
  // eslint-disable-next-line no-bitwise
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16));
}

/**
 * 格式化日期
 */
export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    'Y+': date.getFullYear()
      .toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate()
      .toString(), // 日
    'H+': date.getHours()
      .toString(), // 时
    'M+': date.getMinutes()
      .toString(), // 分
    'S+': date.getSeconds()
      .toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const k in opt) {
    ret = new RegExp(`(${k})`).exec(fmt);
    if (ret) {
      // eslint-disable-next-line no-param-reassign
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')));
    }
  }
  return fmt;
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]')
    .indexOf(key) !== -1 || false;
}
